


























































































import { Component } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import { OpportunityDetailsModule } from '@/store/modules/opportunityDetails';
import OpportunityContactDetailsEdit from '@/components/Opportunities/OpportunityContactDetailsEdit.vue';

@Component({
  name: 'OpportunityContactTab',
  components: { OpportunityContactDetailsEdit },
})
export default class extends GiganautVue {
  get opportunity() { return OpportunityDetailsModule.opportunity; }

  get statusLabel(): string {
    if (!this.opportunity) return '';
    if (this.opportunity.contactId) return 'Existing';
    if (this.opportunity.prospectContactFirstName || this.opportunity.prospectContactLastName) return 'New';
    return '';
  }

  get hasAnyDetails(): boolean {
    if (!this.opportunity) return false;
    return !!(this.opportunity.contact && this.opportunity.contact.person)
      || !!this.opportunity.prospectContactFirstName
      || !!this.opportunity.prospectContactLastName;
  }

  get contactLastNameDisplay(): string {
    if (!this.opportunity) return '';
    if (this.opportunity.contact && this.opportunity.contact.person) return this.opportunity.contact.person.lastName;
    return this.opportunity.prospectContactLastName;
  }

  contactField(linkedKey: string, prospectKey: string): string {
    if (!this.opportunity) return '';
    if (this.opportunity.contact) return (this.opportunity.contact as any)[linkedKey] || '';
    return (this.opportunity as any)[prospectKey] || '';
  }
}
